import { useState } from "react";
import { Modal, Container, Row, Col } from "react-bootstrap";
import CreateShopModal from './ChipzShop.jsx';
import { playSound } from "../../game/scenes/classes/PlaySound";

export default function InsufficientChipzJoinModal(props) {
    const [showShopModal, setShowShopModal] = useState(false);
    const { showModal, setShowModal, requiredAmount, wagerType } = props;

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleGetChipz = () => {
        playSound("clickSound");
        setShowModal(false);
        setShowShopModal(true);
    };

    return (
        <>
            <CreateShopModal
                showShopModal={showShopModal}
                setShowShopModal={setShowShopModal}
            />
            
            <Modal 
                show={showModal} 
                onHide={handleCloseModal} 
                centered 
                className="insufficient-chipz-modal"
            >
                <Modal.Body className="text-center p-4" style={{ backgroundColor: "#1a1f3a", border: "2px solid #585EDD", borderRadius: "15px" }}>
                    <Container>
                        {/* Close button */}
                        <Row className="justify-content-end mb-2">
                            <Col xs="auto">
                                <button 
                                    onClick={handleCloseModal}
                                    style={{ background: "none", border: "none", color: "#fff", fontSize: "24px" }}
                                >
                                    ✕
                                </button>
                            </Col>
                        </Row>

                        {/* Main content */}
                        <Row className="mb-4">
                            <Col>
                                <div style={{ fontSize: "48px", marginBottom: "20px" }}>🚫</div>
                                <h2 style={{ color: "#FF6B6B", fontSize: "32px", fontWeight: "bold", marginBottom: "15px" }}>
                                    Oops! Not Enough Chipz
                                </h2>
                                <p style={{ color: "#FFFFFF", fontSize: "18px", marginBottom: "10px" }}>
                                    You need <span style={{ color: "#00D1FF", fontWeight: "bold" }}>{requiredAmount?.toLocaleString()}</span> {wagerType === "zoom" ? "Chipz" : "Bonez"} to join this match
                                </p>
                                <p style={{ color: "#FFC350", fontSize: "16px", marginBottom: "25px" }}>
                                    Don't miss out on the action! Get your Chipz now and dominate the competition! 💪
                                </p>
                            </Col>
                        </Row>

                        {/* Chipz showcase */}
                        <Row className="mb-4">
                            <Col>
                                <div style={{ 
                                    backgroundColor: "#2a2f4a", 
                                    padding: "20px", 
                                    borderRadius: "10px", 
                                    border: "1px solid #585EDD" 
                                }}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "15px" }}>
                                        <img
                                            src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                            alt="Chipz icon"
                                            style={{ width: "40px", height: "40px", marginRight: "10px" }}
                                        />
                                        <span style={{ color: "#FFFFFF", fontSize: "24px", fontWeight: "bold" }}>
                                            100,000 Chipz
                                        </span>
                                    </div>
                                    <p style={{ color: "#FFC350", fontSize: "20px", fontWeight: "bold", marginBottom: "5px" }}>
                                        Just $0.99!
                                    </p>
                                    <p style={{ color: "#FFFFFF", fontSize: "14px" }}>
                                        Perfect for multiple matches!
                                    </p>
                                </div>
                            </Col>
                        </Row>

                        {/* Action buttons */}
                        <Row>
                            <Col>
                                <button
                                    className="button create-game-button"
                                    onClick={handleGetChipz}
                                    style={{ 
                                        position: "relative",
                                        width: "200px", 
                                        height: "60px",
                                        margin: "0 auto",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <audio id="clickSound" className="sound-fx" hidden>
                                        <source src="/bonez/sounds/click.mp3" type="audio/mp3"/>
                                        Your browser does not support the audio element.
                                    </audio>
                                    <img
                                        src="https://zoombies.world/images/dapp/green_button_400.webp"
                                        alt=""
                                        style={{ width: "100%", height: "100%" }}
                                    />
                                    <span
                                        className="button-text"
                                        style={{ 
                                            color: "#000000", 
                                            fontWeight: "bold", 
                                            fontSize: "18px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px"
                                        }}
                                    >
                                        🛒 GET CHIPZ NOW
                                    </span>
                                </button>
                                
                                <p style={{ color: "#AAAAAA", fontSize: "12px", marginTop: "15px" }}>
                                    Quick & secure payment • Play in seconds
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        </>
    );
} 